/**
 * Phase 18.16-B Batch 3 — /btw-terugvragen PageBanner wrapper.
 *
 * Lives as `topSection` of the /btw-terugvragen CmsPageRenderer route.
 * The legacy "hero" block on the same slug is hidden via
 * `hideBlockTypes={["hero"]}` in App.js and marked "Vervangen" in the
 * Backoffice.
 *
 * NOTE on legal safety: the default banner copy never claims a
 * guaranteed VAT refund — admins editing this page in CMS are also
 * coached (via the admin-tab description) not to add claims like "u
 * krijgt altijd BTW terug".
 */
import React from "react";
import { Receipt } from "lucide-react";
import useInfoPageCms from "../hooks/useInfoPageCms";
import { ToolPageBanner } from "./ToolPageCms";

const FALLBACK = {
  page_banner: {
    eyebrow: "BTW-teruggave",
    title: "BTW terugvragen op",
    highlight: "uw zending",
    subtitle:
      "Algemene informatie over BTW-restitutie bij export buiten de EU. Controleer altijd bij uw leverancier of bij de Belastingdienst of u recht heeft op BTW-teruggave.",
    badges: [
      { icon: "info",    label: "Informatie, geen advies" },
      { icon: "receipt", label: "Export-documenten" },
      { icon: "support", label: "Wij helpen met paperwork" },
    ],
    cta_primary_label: "Neem contact op",
    cta_primary_url: "tel:+31488235999",
    cta_secondary_label: "Mail ons",
    cta_secondary_url: "mailto:info@5999cargo.nl",
  },
  intro: {},
  cta_band: {},
};

export default function BtwPageBanner() {
  const { data } = useInfoPageCms("btw-terugvragen", FALLBACK);
  return (
    <ToolPageBanner
      banner={data?.page_banner || FALLBACK.page_banner}
      image="https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
      imageAlt="BTW-teruggave — informatie en stappenplan"
      eyebrowIcon={Receipt}
      testid="btw-terugvragen-banner"
    />
  );
}
